import { on } from "@ngrx/store";
import { ContractAdminState } from "../contract-admin.state";
import { CatalogManagementActions } from "./catalog-management.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update contractAdmin state within PagesStore
// **************************************************************************

function withContractAdmin(state: PagesStore, updater: (contractAdmin: ContractAdminState) => ContractAdminState): PagesStore {
    return { ...state, contractAdmin: updater(state.contractAdmin) };
}

// **************************************************************************
// CATALOG MANAGEMENT REDUCER (array format for PagesStore)
// Handles admin-specific loading states for catalog CRUD operations
// **************************************************************************

const createCatalog = on(CatalogManagementActions.createCatalog, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    catalogManagement: { ...contractAdminState.catalogManagement, creating: true },
})));

const createCatalogSuccess = on(CatalogManagementActions.createCatalogSuccess, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    catalogManagement: { ...contractAdminState.catalogManagement, creating: false },
    error: null,
})));

const createCatalogFailure = on(CatalogManagementActions.createCatalogFailure, (state: PagesStore, { error }) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    catalogManagement: { ...contractAdminState.catalogManagement, creating: false },
    error,
})));

const deleteCatalog = on(CatalogManagementActions.deleteCatalog, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    catalogManagement: { ...contractAdminState.catalogManagement, deleting: true },
})));

const deleteCatalogSuccess = on(CatalogManagementActions.deleteCatalogSuccess, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    catalogManagement: { ...contractAdminState.catalogManagement, deleting: false },
    error: null,
})));

const deleteCatalogFailure = on(CatalogManagementActions.deleteCatalogFailure, (state: PagesStore, { error }) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    catalogManagement: { ...contractAdminState.catalogManagement, deleting: false },
    error,
})));

const uploadCatalogImage = on(CatalogManagementActions.uploadCatalogImage, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    catalogManagement: { ...contractAdminState.catalogManagement, uploadingImage: true },
})));

const uploadCatalogImageSuccess = on(CatalogManagementActions.uploadCatalogImageSuccess, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    catalogManagement: { ...contractAdminState.catalogManagement, uploadingImage: false },
    error: null,
})));

const uploadCatalogImageFailure = on(CatalogManagementActions.uploadCatalogImageFailure, (state: PagesStore, { error }) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    catalogManagement: { ...contractAdminState.catalogManagement, uploadingImage: false },
    error,
})));

export const catalogManagementReducer = [
    createCatalog,
    createCatalogSuccess,
    createCatalogFailure,
    deleteCatalog,
    deleteCatalogSuccess,
    deleteCatalogFailure,
    uploadCatalogImage,
    uploadCatalogImageSuccess,
    uploadCatalogImageFailure,
];
